class QueryProgress {
  public query = '';
  public offset = 0;
  public isDone = false;

  constructor(query: string) {
    this.query = query;
  }
}
export default QueryProgress;